module.exports = __webpack_public_path__ + "static/media/digital_card.fd210949.svg";